import React, { useEffect, useState } from 'react'
import firebase, { firebaseAnalytics }  from './Firebase';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Card, Spinner } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Company } from '../Company';

export default function Companies() {
    const [company, setCompany] = useState([]);
    const [filteredCompany, setFilteredCompany] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    let history = useHistory();
    const temp = history.location.pathname.split("/")[1]
    var selected = history.location.pathname.split("/")[2] === undefined ? null:  history.location.pathname.split("/")[2] 

    const ref = firebase.firestore().collection('aziende');

    useEffect(() => {
        firebaseAnalytics.logEvent("companies_tab_visited");
        firebaseAnalytics.setCurrentScreen("companies_tab")
        setLoading(true);
        ref.get().then((query)  => updateState(query));
    }, []);

    const updateState = query => {
        const items = [];
        query.forEach(doc => items.push(doc.data()));
        setCompany(items);
        setFilteredCompany(items);
        setLoading(false);
    }

    const searchCompany = (string) => {
        setFilteredCompany( 
            company.filter( comp => comp.nome.toLowerCase().includes(string.toLowerCase()))
          );
    }
    
    const renderCompanies = azienda => (
        <Card className="box card__reviews" key={azienda.id} onClick={() => { history.push("/aziende/" + azienda.nome) }}>
            <Card.Img  variant="top" src={azienda.logo} style={{borderRadius: "20px"}}/>
            <Card.Body>
                <Card.Title>{azienda.nome}</Card.Title>
            </Card.Body>
        </Card>
    );

    return (
        <>
            {loading ? 
                <h2 style={{ color: 'white' }}>
                    <Spinner animation="grow" />
                </h2>:
                (temp === "aziende" && selected ? 
                        <div className="conteinerRecensioni">
                            <Company azienda={selected}/>
                        </div>
                    : 
                        <>
                            <div style={{justifyContent: "center", marginBottom: "1%" }}>
                                <input className='input' type='text' placeholder='🔍 Cerca...' style={{width: "150px"}} 
                                onChange={event => {
                                    searchCompany(event.target.value);
                                    setSearch(event.target.value);
                                }}
                                />
                                <text style={{ color:"white", paddingLeft: "2%"}}>aziende: {filteredCompany.length}</text>
                            </div>
                            <div className="conteinerRecensioni">
                                {filteredCompany.map(data => renderCompanies(data))}
                            </div>
                        </>
                        
                )
            }
            
            
        </>
    );
}